import { AdminAccountIndemnitySummary } from "@portal/api/account/admin";
import { FC } from "react";
import { IndemnitorRow } from "./IndemnitorRow";

export type AdminAccountRequiredIndemnitorsListProps = {
	indemnitySummary: AdminAccountIndemnitySummary;
};

export const AdminAccountRequiredIndemnitorsList: FC<AdminAccountRequiredIndemnitorsListProps> = ({
	indemnitySummary,
}) => {
	return (
		<div
			data-testid="admin-account-required-indemnitors"
			className="flex flex-col space-y-[14px] w-full min-w-[70%] auto-rows-min"
		>
			<div className="flex flex-col space-y-2">
				{indemnitySummary.requiredIndemnitors.companies.map((indemnitor, index) => (
					<IndemnitorRow key={index} name={indemnitor.name} />
				))}
				{indemnitySummary.requiredIndemnitors.individuals.map((indemnitor, index) => (
					<IndemnitorRow key={index} name={indemnitor.name} email={indemnitor.email} />
				))}
			</div>
		</div>
	);
};
